<template>
    <div>
        <div v-if="isConnected()">
            <HelpWidget />
            <AppLayoutV2>
                <template #sidebar>
                    <MenuV2 />
                </template>
                <template #topbar>
                    <TopBarV2>
                        <template #actions>
                            <ButtonCreateV2 />
                            <ButtonExportPostsV2 />
                        </template>
                    </TopBarV2>
                </template>
                <router-view :key="$route.fullPath"></router-view>
            </AppLayoutV2>
        </div>
        <div v-else>
            <div class="page-wrapper">
                <div class="page-inner">
                    <div class="page-content-wrapper bg-brand-gradient">
                        <fade-transition
                            origin="center"
                            mode="out-in"
                            :duration="250"
                        >
                            <router-view></router-view>
                        </fade-transition>
                    </div>
                </div>
            </div>
        </div>
        <BmvLoader v-model="loading" full-page />
        <portal-target name="icon-picker-portal" multiple />
        <portal-target name="topbar-portal" multiple />
    </div>
</template>

<style scoped>
</style>

<style>
.ck.ck-content ul,
.ck.ck-content ul li {
    list-style-type: inherit;
}

.ck.ck-content ol,
.ck.ck-content ol li {
    list-style-type: number;
}

.ck.ck-content ul,
.ck.ck-content ol {
    /* Default user agent stylesheet, you can change it to your needs. */
    padding-left: 20px;
}

/* Global focus styles for inputs */
input:focus,
textarea:focus,
select:focus,
.form-control:focus {
    border-color: #0891B2 !important;
    box-shadow: 0 0 0 3px rgba(8, 145, 178, 0.12) !important;
    outline: none !important;
}
</style>

<script>
import { FadeTransition } from 'vue2-transitions'

import AppLayoutV2 from '@/components/Layout/v2/AppLayoutV2.vue'
import MenuV2 from '@/components/Layout/v2/MenuV2.vue'
import TopBarV2 from '@/components/Layout/v2/TopBarV2.vue'
import HelpWidget from '@/components/Layout/v2/HelpWidget.vue'
import ButtonCreateV2 from '@/components/UI/Menu/v2/ButtonCreateV2.vue'
import ButtonExportPostsV2 from '@/components/UI/Menu/v2/ButtonExportPostsV2.vue'
import BmvLoader from '@/components/UI/v2/BmvLoader.vue'

import { getEcho } from '@/services/echo'

import { mapActions, mapGetters, mapState } from 'vuex'

export default {
    name: 'App',
    components: {
        AppLayoutV2,
        MenuV2,
        TopBarV2,
        HelpWidget,
        ButtonCreateV2,
        ButtonExportPostsV2,
        BmvLoader,
        FadeTransition
    },
    data: function () {
        return {
            loading: false
        }
    },
    computed: {
        ...mapGetters('admin', [
            'getIsUnderImpersonation',
            'getUserImpersonated'
        ]),
        ...mapState('auth', { authUser: (s) => s.user })
    },
    watch: {
        authUser: {
            immediate: true,
            handler(user, prevUser) {
                if (prevUser && prevUser.id && (!user || user.id !== prevUser.id)) {
                    const echo = getEcho()
                    if (echo) echo.leave(`App.Models.User.${prevUser.id}`)
                }
                if (user && user.id) {
                    this.$store.dispatch('notifications/fetchAll')
                    const echo = getEcho()
                    if (!echo) return
                    echo.private(`App.Models.User.${user.id}`)
                        .error((err) => console.error('❌ user channel auth/sub error:', err))
                        .notification((notification) => {
                            this.$store.dispatch('notifications/receiveBroadcastNotification', notification)
                        })
                }
            }
        }
    },
    mounted() {
        document.documentElement.classList.add('ui-v2')
        document.body.classList.add('header-function-fixed')
        if (this.getIsUnderImpersonation) {
            document.body.classList.add('is-impersonating')
        }
        if (this.isConnected()) {
            this.$store.dispatch('auth/fetchMe').catch(() => {})
        }
    },
    methods: {
        ...mapActions('admin', ['leaveImpersonate']),
        leaveImpersonateUser() {
            this.loading = true
            this.leaveImpersonate()
                .then(() => {
                    window.location.href = '/'
                })
        },
        isConnected() {
            var token = localStorage.getItem('token')
            return token && token.length > 0
        }
    }
}
</script>
